// extracted by mini-css-extract-plugin
module.exports = {"cls1":"PageLayout-CssProp2_div-module--cls1--3nfXQ","cls2":"PageLayout-CssProp2_div-module--cls2--1eEh1 PageLayout-CssProp2_div-module--cls1--3nfXQ"};